@if (loading()) {
  <div class="last-ride-card last-ride-card--loading">Učitavanje zadnje vožnje...</div>
} @else if (lastRide()) {
  <a class="last-ride-card" [routerLink]="['/ride-details', lastRide()!.id]">
    <div class="last-ride-card__thumb">
      <app-mini-map [rideId]="lastRide()!.id"></app-mini-map>
    </div>
    <div class="last-ride-card__info">
      <span class="last-ride-card__badge">Zadnja vožnja</span>
      <span class="last-ride-card__title">{{ lastRide()!.rideName }}</span>
      <span class="last-ride-card__date">Datum: {{ lastRide()!.date | date:'dd.MM.yyyy.' }}</span>
      <span class="last-ride-card__stats">
        {{ lastRide()!.distance | distanceConverter }} · {{ lastRide()!.duration | duration }}
      </span>
    </div>
  </a>
}